import React, { useMemo } from 'react'
import { BorderContainer } from '../../BorderContainer'
import { Margin } from '../../Margin'
import { SubstanceItem } from '../style'

export const Substance = props => {
    const { pimData, topicsId, modulesId } = props

    const printPimData = (arrOfId, data) => {
        return arrOfId.map((id, idx) => {
            const example = data.find( i => i.id == id)
            return <SubstanceItem key={id}>{idx + 1}. {example.name}</SubstanceItem>
        })
    }

    return useMemo(() =>(
        <BorderContainer>
            <h4>Содержание ПИМ</h4>
            <strong>Блок 1. Темы</strong>
            <Margin left='20px' bottom={topicsId.lenght > 0 ? '20px' : '0'}>
                {printPimData(topicsId, pimData.topics)}
            </Margin>
            <strong>Блок 2. Модули</strong>
            <Margin left='20px' bottom={modulesId.lenght > 0 ? '20px' : '0'}>
                {printPimData(modulesId, pimData.modules)}
            </Margin>
            <strong>Блок 3. Кейс-задания</strong>
            {pimData.cases.map((c, idx) => {
                return (
                    <Margin left='20px' bottom='10px' key={idx}>
                        <SubstanceItem>{idx + 1}. {c.name}</SubstanceItem>
                        <Margin left='10px'>
                            {c.topics.map((sub, subIdx) => {
                                return <SubstanceItem key={sub.id}>{idx + 1}.{subIdx + 1} {sub.name}</SubstanceItem>
                            })}
                        </Margin>
                    </Margin>
                )
            })}
        </BorderContainer>
    ), [topicsId, modulesId])
}
